import IDateMonthYear from '../../shared/interfaces/datapicker.interface'

export const DATE_MONTH_YEAR: IDateMonthYear ={
    labelText: 'Buscar por fecha',
    minDate: new Date('2010-01-02'),
    maxDate: new Date(),
    valueDate: new Date(),
    okText: 'Filtrar',
    cancelText: 'Cancelar',
}